import React, { useState, useMemo } from 'react'
import "../css/gallery.css"
import { ButtonGroup, Card, Col, Container, Row, ToggleButton } from 'react-bootstrap'
import { Events_category } from '../assets/assets.js';
import Aos from 'aos';
import { useEffect } from 'react';
import "aos/dist/aos.css";

export const Gallery = () => {

  useEffect(() => {
    Aos.init({ duration: 1000 })
  }
  );

  const [radioValue, setRadioValue] = useState('1');
  const [selectcategory, setSelectcategory] = useState("all");

  const filteredCategory =
    selectcategory === "all"
      ? Events_category
      : Events_category.filter((e) => selectcategory === e.type);

  // ✅ Shuffle logic using useMemo (so it only runs when category changes)
  const shuffledCategory = useMemo(() => {
    const shuffled = [...filteredCategory];
    for (let i = shuffled.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]];
    }
    return shuffled;
  }, [filteredCategory]);

  const radios = [
    { name: 'All Events', type: "all", value: '1' },
    { name: 'Wedding', type: "wedding", value: '2' },
    { name: 'Reception', type: "reception", value: '3' },
    { name: 'Birthday', type: "birthday", value: '4' },
    { name: 'Anniversary', type: "aniversary", value: '5' },
  ];

  return (
    <>
      <Container
        fluid
        className="gallery-header d-flex justify-content-start align-items-center"
      >
        <Row>
          <Col data-aos="fade-up" data-aos-delay="100">
            <h1 className="gallery-title">Gallery</h1>
          </Col>
        </Row>
      </Container>

      <Container fluid style={{ padding: "2rem" }}>
        <Row>
          <Col
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              padding: "1rem",
              marginBottom: "10px",
            }}
          >
            <ButtonGroup style={{ gap: "1rem", flexWrap: "wrap" }}>
              {radios.map((radio, idx) => (
                <ToggleButton
                  key={idx}
                  id={`radio-${idx}`}
                  type="radio"
                  name="radio"
                  value={radio.value}
                  checked={radioValue === radio.value}
                  onChange={(e) => setRadioValue(e.currentTarget.value)}
                  onClick={() => setSelectcategory(radio.type)}
                  className={`event-toggle-btn ${radioValue === radio.value ? "active" : ""}`}
                >
                  {radio.name}
                </ToggleButton>
              ))}
            </ButtonGroup>
          </Col>
        </Row>

        <Row>
          {shuffledCategory.map((e) => (
            
            <Col data-aos="zoom-in-up" data-aos-delay="60" key={e.id} md={3} className="mb-4">
              <Card className="gallery-card">
                <div className="image-wrapper">
                  <Card.Img className="events-img" src={e.img} />
                  <div className="overlay">
                    <span className="overlay-text">{e.name}</span>
                  </div>
                </div>
              </Card>
            </Col>
          ))}
        </Row>
      </Container>
    </>
  )
}
